import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SearchItem } from 'src/app/models/searchItem';
import { Shortcuts } from 'src/app/models/Shortcuts';
import { ShortcutsModalControlService } from 'src/app/popup/configurations/services/shortcuts-modal-control.service';
import { ShortcutsManagementComponent } from 'src/app/popup/shortcuts-management/shortcuts-management.component';
import { ContextualHelpService } from 'src/app/services/contextualHelpService';
import { ModalConfirmationService } from 'src/app/services/modal-confirmation.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { SearchService } from 'src/app/services/search.service';
import {GritUserService} from "../../services/grit/grit.user.service";

@Component({
  selector: 'app-shortcuts',
  templateUrl: './shortcuts.component.html',
  styleUrls: ['./shortcuts.component.scss'],
  standalone: false
})
export class ShortcutsComponent implements OnInit {

  constructor(public shortcutsService : ShortcutsModalControlService,
    public searchService : SearchService,
    private modalService : BsModalService,
    private modelConfirmationMessage : ModalConfirmationService,
    public contextualHelpService: ContextualHelpService,
    public modalMessage: ModalControlService,
              public gritUserService: GritUserService) {
   }

  ngOnInit(): void {
  }
  callAction(shortcut:SearchItem){
    if(this.contextualHelpService.isMenuOptionEnabled(shortcut.name)){
      shortcut.action();
    }
    else{
      this.modalMessage.showMesssageModal("Error",ContextualHelpService.UNAVAILABLE_OPTION);
    }
  }
  openShortcutsList() : void{
    const bsModalRef : BsModalRef = this.modalService.show(ShortcutsManagementComponent);
  }

  checkDelete(shortcut : SearchItem) {
    this.modelConfirmationMessage.showMesssageConfirmationModal("Delete Shortcut", "Do you want to delete the shortcut with the name '" + shortcut.name + "'?", 'Yes', 'No', () => this.deleteShortcut(shortcut));

  }
  deleteShortcut(shortcut : SearchItem) : void {
    const removeIndex = this.shortcutsService.shortcuts.findIndex( item => item === shortcut );
    // remove object
    if (removeIndex != -1){
      this.shortcutsService.shortcuts.splice( removeIndex, 1 );
      this.shortcutsService.deleteShortcut(shortcut.shortcutId);
    }
  }


}
